const RadioGroup = ({ label, value, options, onChange }: { label: string, value: string, options: string[], onChange: (newValue: string) => void }) => {
  return (
    <div className="vintage-controls radio-group">
      <div style={{ transform: 'translate(0.5rem, 0.6rem)', backgroundColor: '#F0F0F0', width: 'max-content', paddingInline: '0.25rem' }}>
        {label}
      </div>
      <div className='d-flex flex-row align-items-center p-2 px-3 pt-3' style={{ gap: '1rem', border: '1px solid #CDCDCD', borderRadius: '0.125rem' }}>
        {
          options.map(o =>
            <div key={o} className='d-flex flex-row align-items-center' style={{ gap: '0.25rem' }}>
              <input
                type="radio"
                id={o}
                checked={value === o}
                onChange={() => onChange(o)}
              />
              <label htmlFor={o}>{o}</label>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default RadioGroup;
